module.exports = __webpack_public_path__ + "static/media/logo2.a3f01a86.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/logo2.png
// module id = 261
// module chunks = 228